// extracted by mini-css-extract-plugin
export default {"about":"AboutInfo_about__DglqE","about_content":"AboutInfo_about_content__b8auR","big_image":"AboutInfo_big_image__FK1Ue"};